import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap space-y-5 lg:space-y-0"
}
const _hoisted_2 = { class: "relative w-full lg:w-[300px] rounded-2xl overflow-hidden bg-white border border-gray-900/[.04]" }
const _hoisted_3 = { class: "relative aspect-w-16 aspect-h-9" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "font-bold text-darkgray-800" }
const _hoisted_7 = { class: "w-full lg:w-[calc(100%-300px)] pl-5 space-y-1 text-darkgray-900" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import { format } from 'date-fns'
import { computed, onMounted, ref } from 'vue';
import BranchService from "@/classes/Branch";
import DateFormatter from '@/helpers/DateFormatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentImageCard',
  props: {
    appointmentToday: {
        type: Object,
    }
},
  setup(__props) {

const props = __props;

const branchImage = ref(null)
const storageUrl = computed(() => process.env.VUE_APP_API_STORAGE_URL);

const fetchBranch = async () => {
    console.log("Wew")
    try {
        const response = await BranchService.editBranch(props.appointmentToday?.branch_id)

        const branchResponse = response.data.branch;

        if(branchResponse) {
            console.log('hello');
            // branchImage.value = branchResponse.image_path ? `${storageUrl.value}${branchResponse.image_path}` : '/assets/images/shinagawa-bgc-branch.jpeg';
            branchImage.value = branchResponse.image_path ? branchResponse.full_image_path : '/assets/images/shinagawa-bgc-branch.jpeg';
        }
    }
    catch(error: any) {
        console.log(error)
    }
}

onMounted( () => {
    // setTimeout(() => {
        if(props.appointmentToday?.branch_id) {
            fetchBranch();
        }   
    // }, 1000);
})

return (_ctx: any,_cache: any) => {
  return (__props.appointmentToday)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: branchImage.value,
              alt: "",
              class: "absolute top-0 left-0 object-cover w-full h-full"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.appointmentToday.branch_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(__props.appointmentToday.package_name ?? 'Japanese Standard Health Checkup'), 1),
          _createElementVNode("p", _hoisted_9, [
            _createTextVNode(_toDisplayString(__props.appointmentToday.booking_date ? 
                    _unref(format)(new Date(__props.appointmentToday.booking_date ), 'EEE, MMM dd') 
                    : _unref(format)(new Date(), 'EEE, MMM dd')) + " ", 1),
            (__props.appointmentToday.booking_type == 'Individual')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " | " + _toDisplayString(__props.appointmentToday.booking_start_time ? _unref(DateFormatter).customDateFormat(__props.appointmentToday.booking_start_time, 'h:mm a',  "UTC") : 'TBA') + " - " + _toDisplayString(__props.appointmentToday.booking_end_time ?  _unref(DateFormatter).customDateFormat(__props.appointmentToday.booking_end_time, 'h:mm a',  "UTC") : 'TBA'), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, " No appointment scheduled for today "))
}
}

})